(() => {
  if (customElements.get('km-featured-sidebar')) return;
  customElements.define('km-featured-sidebar', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      // Category collections have their own filters outside the results section.
      // Keep the configured widget below those filters, including after sorting.
      const sidebar = document.querySelector('.km-category-sidebar');
      if (sidebar && !sidebar.contains(this)) {
        const previous = sidebar.querySelector('km-featured-sidebar');
        if (previous) previous.replaceWith(this);
        else sidebar.append(this);
      }
      const slides = [...this.querySelectorAll('[data-featured-slide]')];
      const controls = this.querySelector('.km-featured-sidebar__controls');
      if (!controls || slides.length < 2) return;
      let index = 0;
      const show = (step) => {
        slides[index].hidden = true;
        index = (index + step + slides.length) % slides.length;
        slides[index].hidden = false;
        this.setAttribute('aria-label', `Featured Products: ${slides[index].querySelector('h3').textContent.trim()}`);
      };
      this.querySelector('[data-featured-prev]').addEventListener('click', () => show(-1));
      this.querySelector('[data-featured-next]').addEventListener('click', () => show(1));
      controls.hidden = false;
    }
  });
})();
